import './GlowSubWidgets.css';
import React, { useState } from "react";
import OutOfTen from '../../components/OutOfTen';

function InputBlock(props) {
    const [input1, setInput1] = useState(5)
    const [input2, setInput2] = useState(5)
    const [input3, setInput3] = useState(5)
    const [textInput1, setTextInput1] = useState("")
    const [textInput2, setTextInput2] = useState("")

    const handleInput1Change = (event) => {
        setTextInput1(event.target.value)
    }

    const handleInput2Change = (event) => {
        setTextInput2(event.target.value)
    }



    return (
        <div className="glowBlockSubWidget">
            <p className="glowHeaderText"> input </p>
            {props.subtype === "morning" &&
                <div>
                    <div className="sleepRatingRow">
                        <p className="numberInputTextRating"> total hours of sleep: </p>
                        <input className="numberInputRating" onChange={handleInput1Change} id="hoursOfSleep" type="text" value={textInput1} />
                    </div>
                    <div className="sleepRatingRow">
                        <p className="numberInputTextRating"> wake up time:</p>
                        <input className="numberInputRating" onChange={handleInput2Change} id="wakeUpTime" type="text" value={textInput2} />
                    </div>
                    <OutOfTen selectedRating={input3} setSelectedRating={setInput3} title="sleep quality" left="extremely poor" right="extremely high" />
                </div>
            }
            {props.subtype === "evening" &&
                <div>
                    <OutOfTen selectedRating={input1} setSelectedRating={setInput1} title="daytime sleepiness level:" left="extremely sleepy" right="extremely alert" />
                    <OutOfTen selectedRating={input2} setSelectedRating={setInput2} title="stress level:" left="extremely stressed" right="extremely relaxed" />
                    <OutOfTen selectedRating={input3} setSelectedRating={setInput3} title="mental clarity:" left="extremely groggy" right="extremely clear" />
                </div>
            }
        </div>
    )
}

export default InputBlock;